import Loadable from 'react-loadable';
import { LCLoading } from 'control/loading';

const Login = Loadable({
  loader: () => import('./components/Login'),
  loading: LCLoading,
});
export { Login };
